import ShoppingCart from './ShoppingCart.jsx';
import style from './style.scss';

export {
  ShoppingCart
};



// WEBPACK FOOTER //
// ./components/users/sub-view/shopping-cart/index.js